























import { Component, Vue } from 'vue-property-decorator'
import { FillInfoItemOfForm, OperationItemType, OptionItemType } from '../../types/type'
import { getAllFatherNodeForTree, findItemForTree } from '../../utils/toolsForCommon'
import { CommonModule, UserModule, CanteenModule } from '../../store'
@Component({
  name: 'AddOrUpdateIncomeAndExpenses',
  components: {
    'form-module': () => import('../../components/common/formModule.vue')
  }
})
export default class AddOrUpdateIncomeAndExpenses extends Vue {
  public loading = false
  public headerOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]
  public bottomOperationListForAddOrUpdateAtSchoolStudents: Array<OperationItemType> = [
    {
      title: `保存`,
      key: 'save',
      type: 'success',
      size: ''
    }
  ]
  // 枚举选项：
  public optionsForIncOrExp: Array<OptionItemType> = [
    {
      name: '收入',
      value: true
    },
    {
      name: '支出',
      value: false
    }
  ]
  public optionsForBillType: Array<OptionItemType> = [
    {
      name: '增值税发票',
      value: 1
    },
    {
      name: '自制凭证',
      value: 2
    },
    {
      name: '工资单',
      value: 3
    }
  ]
  public fillInfoList: Array<FillInfoItemOfForm> = [
    {
      title: '学校',
      type: 'cascader',
      key: 'organizationName',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      schoolItem: {},
      isNecessary: true,
      temporaryStorageForValue: null
    },
    {
      title: '摘要',
      type: 'textarea',
      key: 'summary',
      value: '',
      placeholder: '请输入摘要',
      isNecessary: true
    },
    {
      title: '科目',
      type: 'cascaderForcode',
      key: 'subject',
      value: '',
      placeholder: '请选择科目',
      treeData: [],
      treeItem: {},
      isNecessary: true,
      filterable: true
    },
    {
      title: '时间',
      type: 'dateForDate',
      key: 'time',
      value: '',
      placeholder: '请选择时间',
      isNecessary: true
    },
    {
      title: '收支',
      type: 'select',
      key: 'incOrExp',
      value: '',
      placeholder: '请选择收入或支出',
      selectOptions: [],
      isNecessary: true
    },
    {
      title: '资金形式',
      type: 'cascaderForcode',
      // 这个是新加的：
      // 为了只能选择末节点：
      props: {
        expandTrigger: 'click',
        children: 'children',
        label: 'name',
        checkStrictly: false,
        value: 'code'
      },
      key: 'capitalType',
      value: '',
      placeholder: '请选择资金形式',
      treeData: [],
      treeItem: {},
      isNecessary: true,
      filterable: true
    },
    {
      title: '金额（元）',
      type: 'number',
      key: 'money',
      value: '',
      placeholder: '请输入金额',
      isNecessary: true
    },
    {
      title: '数量',
      type: 'number',
      key: 'amount',
      value: '',
      placeholder: '请输入数量',
      isNecessary: true,
      hide: true
    },
    {
      title: '单位',
      type: 'text',
      key: 'unit',
      value: '',
      placeholder: '请输入单位',
      isNecessary: true,
      hide: true,
      explainText: '选择科目会自动补全单位'
    },
    {
      title: '票据类型',
      type: 'select',
      key: 'billType',
      value: '',
      placeholder: '请选择票据类型',
      selectOptions: [],
      isNecessary: true,
      hide: true
    },
    {
      title: '发票',
      type: 'photoForList',
      key: 'billImg',
      value: '',
      placeholder: '请上传发票',
      isNecessary: true,
      imgList: [],
      explainText: '说明：可上传多张图片',
      hide: true,
      hideForbillType: true
    },
    {
      title: '发票编号',
      type: 'text',
      key: 'billNo',
      value: '',
      placeholder: '请输入发票编号',
      isNecessary: true,
      hide: true,
      hideForbillType: true
    },
    {
      title: '工资单图片',
      type: 'photoForList',
      key: 'payrollImg',
      value: '',
      placeholder: '请上传工资单图片',
      isNecessary: true,
      imgList: [],
      explainText: '说明：可上传多张图片',
      hide: true,
      hideForbillType: true
    },

    {
      title: '转账截图',
      type: 'photoForList',
      key: 'transferImg',
      value: '',
      placeholder: '请上传转账截图',
      isNecessary: true,
      imgList: [],
      explainText: '说明：可上传多张图片',
      hide: true,
      hideForbillType: true
    },
    {
      title: '凭证图片',
      type: 'photo',
      key: 'voucherImg',
      value: '',
      placeholder: '请上传凭证',
      isNecessary: true,
      hide: true,
      hideForbillType: true
    },
    {
      title: '备注',
      type: 'textarea',
      key: 'comment',
      value: '',
      placeholder: '请输入备注',
      isNecessary: false
    }
  ]
  public subjectUnitList: any[] = []
  public subjectUnitMap: Map<string, string> = new Map()

  // 新增编辑的文字展示
  get addOrUpdateTitle (): string {
    let _that: any = this
    let { id } = _that.$route.query
    let res: string = '新增'
    if (id && id !== 'add') {
      res = '编辑'
    }
    return res
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  get userInfo () {
    return UserModule.userInfo
  }

  async created () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization(),
      CanteenModule.getTreeDataForDisposeNameSubject(),
      this.getCanteenCommonQuerySubjectUnit()
    ])
    this.disposeForFillInfoList()
    let { id } = (this as any).$route.query
    if (!id) return (this as any).$router.go(-1)
    if (id !== 'add') this.getDetailInfo()
  }

  // 选择框数据处理
  disposeForFillInfoList () {
    this.fillInfoList = this.fillInfoList.map(item => {
      switch (item.key) {
        case 'organizationName':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          item.temporaryStorageForValue = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
        case 'subject':
        case 'capitalType':
          item.treeData = this.treeDataForDisposeNameSubject
          break
        case 'incOrExp':
          item.selectOptions = this.optionsForIncOrExp
          break
        case 'billType':
          item.selectOptions = this.optionsForBillType
          break
        case 'time':
          const { time } = this.$route.query
          if (time) {
            item.value = time
          } else {
            item.value = ''
          }
          break
      }
      return item
    })
  }

  getInputChange (item): void {
    let { key, value } = item
    if (key === 'money') {
      if (Number(value) > 200) {
        this.fillInfoList = this.fillInfoList.map(v => {
          if (v.key === 'billType') {
            v.selectOptions = [
              {
                name: '增值税发票',
                value: 1
              },
              {
                name: '工资单',
                value: 3
              }
            ]
          }
          return v
        })
      } else {
        this.fillInfoList = this.fillInfoList.map(v => {
          if (v.key === 'billType') {
            v.selectOptions = this.optionsForBillType
          }
          return v
        })
      }
    }
  }

  getSelectChange (item): void {
    let { key, value } = item
    if (key === 'incOrExp') {
      if (value) {
        this.fillInfoList = this.fillInfoList.map(v => {
          if (
            v.key === 'amount' ||
            v.key === 'unit' ||
            v.key === 'billType' ||
            v.key === 'voucherImg' ||
            v.key === 'transferImg' ||
            v.key === 'billImg' ||
            v.key === 'billNo' ||
            v.key === 'payrollImg'
          ) {
            v.hide = true
          } else {
            v.hide = false
          }
          return v
        })
      } else {
        this.fillInfoList = this.fillInfoList.map(v => {
          v.hide = false
          return v
        })
      }
    } else if (key === 'billType') {
      switch (value) {
        case 1:
          this.fillInfoList = this.fillInfoList.map(v => {
            if (v.key === 'voucherImg' || v.key === 'payrollImg') {
              v.hideForbillType = true
            } else {
              v.hideForbillType = false
            }
            return v
          })
          break
        case 2:
          this.fillInfoList = this.fillInfoList.map(v => {
            if (
              v.key === 'transferImg' ||
              v.key === 'billImg' ||
              v.key === 'billNo' ||
              v.key === 'payrollImg'
            ) {
              v.hideForbillType = true
            } else {
              v.hideForbillType = false
            }
            return v
          })
          break
        case 3:
          this.fillInfoList = this.fillInfoList.map(v => {
            if (
              v.key === 'voucherImg' ||
              v.key === 'billImg' ||
              v.key === 'billNo'
            ) {
              v.hideForbillType = true
            } else {
              v.hideForbillType = false
            }
            return v
          })
          break
      }
    }
  }

  getCascaderForcodeChange (event, item): void {
    let { key, value } = item
    if (key === 'subject') {
      this.fillInfoList = this.fillInfoList.map(v => {
        if (v.key === 'unit') {
          if (value.length) {
            const res = value[value.length - 1]
            if (this.subjectUnitMap.has(res)) {
              v.value = this.subjectUnitMap.get(res)
            } else {
              v.value = ''
            }
          }
        }
        return v
      })
    }
  }

  async getDetailInfo () {
    try {
      let _that: any = this
      this.loading = true
      let params = {
        id: this.$route.query.id,
        orgId: this.$route.query.orgId
      }
      let { data: result } = await _that.$http.journalQuery(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      let info = result.data.records[0] || {}
      this.fillInfoList = this.fillInfoList.map(item => {
        const { key } = item
        switch (key) {
          case 'organizationName':
            item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', info['orgId'])
            item.temporaryStorageForValue = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', info['orgId'])
            break
          case 'subject':
          case 'capitalType':
            item.value = getAllFatherNodeForTree(this.treeDataForDisposeNameSubject, 'children', 'code', info[key])
            break
          case 'billImg':
          case 'payrollImg':
          case 'transferImg':
            item.imgList = (info[key] ? (info[key]).split(',') : []).map(v => {
              return {
                url: v
              }
            })
            item.value = info[key]
            break
          default:
            item.value = info[key]
            break
        }
        return item
      })
      if (info['incOrExp']) {
        this.fillInfoList = this.fillInfoList.map(v => {
          if (
            v.key === 'amount' ||
            v.key === 'unit' ||
            v.key === 'billType' ||
            v.key === 'voucherImg' ||
            v.key === 'transferImg' ||
            v.key === 'billImg' ||
            v.key === 'billNo' ||
            v.key === 'payrollImg'
          ) {
            v.hide = true
          } else {
            v.hide = false
          }
          return v
        })
      } else {
        this.fillInfoList = this.fillInfoList.map(v => {
          v.hide = false
          return v
        })
      }
      switch (info['billType']) {
        case 1:
          this.fillInfoList = this.fillInfoList.map(v => {
            if (v.key === 'voucherImg' || v.key === 'payrollImg') {
              v.hideForbillType = true
            } else {
              v.hideForbillType = false
            }
            return v
          })
          break
        case 2:
          this.fillInfoList = this.fillInfoList.map(v => {
            if (
              v.key === 'transferImg' ||
              v.key === 'billImg' ||
              v.key === 'billNo' ||
              v.key === 'payrollImg'
            ) {
              v.hideForbillType = true
            } else {
              v.hideForbillType = false
            }
            return v
          })
          break
        case 3:
          this.fillInfoList = this.fillInfoList.map(v => {
            if (
              v.key === 'voucherImg' ||
              v.key === 'billImg' ||
              v.key === 'billNo'
            ) {
              v.hideForbillType = true
            } else {
              v.hideForbillType = false
            }
            return v
          })
          break
      }
      if (Number(info['money']) > 200) {
        this.fillInfoList = this.fillInfoList.map(v => {
          if (v.key === 'billType') {
            v.selectOptions = [
              {
                name: '增值税发票',
                value: 1
              },
              {
                name: '工资单',
                value: 3
              }
            ]
          }
          return v
        })
      } else {
        this.fillInfoList = this.fillInfoList.map(v => {
          if (v.key === 'billType') {
            v.selectOptions = this.optionsForBillType
          }
          return v
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  async saveAll (continuousValue) {
    try {
      let _that: any = this
      let whoEmpty = null
      let isEmpty = this.fillInfoList.some(item => {
        if (!item.hide && !item.hideForbillType && item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      let params = this.fillInfoList.reduce((result, current) => {
        const { key, value } = current
        if (!current.hide || !current.hideForbillType) {
          switch (key) {
            case 'organizationName':
              let { name, id } = current.temporaryStorageForValue
              result['orgName'] = name
              result['orgId'] = id
              break
            case 'subject':
            case 'capitalType':
              result[key] = value[(value || []).length - 1]
              break
            default:
              result[key] = value
              break
          }
        } else {
          result[key] = ''
        }
        return result
      }, {})
      let { id } = this.$route.query
      let apiName = 'journalBookkeeping'
      if (id && id !== 'add') {
        Object.assign(params, { id })
        apiName = 'journalUpdate'
      }
      let { data: result } = await _that.$http[apiName](params)
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(`收支流水${this.addOrUpdateTitle}成功`)
      setTimeout(() => {
        if (continuousValue) {
          const routerParams = {
            id: 'add'
          }
          const obj = this.fillInfoList.find(item => item.key === 'time')
          if (obj) {
            Object.assign(routerParams, {
              time: obj.value
            })
          }
          this.$router.replace({ name: 'AddOrUpdateIncomeAndExpenses', query: routerParams }, () => {
            window.location.reload()
          })
        } else {
          this.$router.push({ name: 'IncomeAndExpenses', query: { refresh: '1' } })
        }
      }, 500)
    } catch (err) {
      console.log(err)
    }
  }

  getFormResultFromChild (result) {
    let { key, value } = result
    this.fillInfoList.forEach(item => {
      if (item.key === key) {
        switch (key) {
          // 学校：
          case 'organizationName':
            item.temporaryStorageForValue = value
            break
          case 'billImg':
          case 'payrollImg':
          case 'transferImg':
            item.imgList.push({
              url: value
            })
            item.value = item.imgList.map(item => item.url).join(',')
            break
          default:
            item.value = value
            break
        }
      }
    })
  }

  // 拿到多张图片：
  getFormResultForHandleRemoveForPhotoForList (result): void {
    let { key, value } = result
    this.fillInfoList = this.fillInfoList.map(item => {
      if (item.key === key) {
        switch (key) {
          case 'billImg':
          case 'payrollImg':
          case 'transferImg':
            item.imgList = value.map(item => {
              return {
                url: item.url
              }
            })
            item.value = item.imgList.map(item => item.url).join(',')
            break
        }
      }
      return item
    })
  }

  async getCanteenCommonQuerySubjectUnit () {
    try {
      const { data: result } = await (this as any).$http.canteenCommonQuerySubjectUnit()
      if (result.code !== 200) return this.$message.error(result.msg)
      this.subjectUnitList = result.data
      this.subjectUnitList.forEach(item => {
        let { subject, unit } = item
        this.subjectUnitMap.set(subject, unit)
      })
    } catch (err) {
      console.log(err)
    }
  }

  operationForButton ({ key }) {
    switch (key) {
      case 'back':
        this.$router.go(-1)
        break
      case 'save':
        this.saveAll((this as any).$refs.refOfFormModule.continuousValue)
        break
    }
  }
}
